import { unwrapResult } from '@reduxjs/toolkit';
import { useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { ExtensiveAttributeModel, NotDataAuthorizationQuery, ContentTagServiceAccessPermissionQuery } from 'types/entity';
import { extensiveAttributeDefinitionReadQuery } from './extensive-attribute-definition-read.selector';
import { extensiveAttributeDefinitionReadActions } from './extensive-attribute-definition-read.slice';

export const useExtensiveAttributeDefinitionReadFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  const loaded = useAppSelector(extensiveAttributeDefinitionReadQuery.getLoaded);

  const extensiveAttributeDefinitions: ExtensiveAttributeModel[] = useAppSelector(extensiveAttributeDefinitionReadQuery.getExtensiveAttributeDefinitions);

  const loadExtensiveAttributeDefinitions = useCallback(
    (selectedProjectId: string, notDataAuthorization: NotDataAuthorizationQuery, contentTagServiceAccessPermission: ContentTagServiceAccessPermissionQuery) => dispatch(extensiveAttributeDefinitionReadActions.loadExtensiveAttributeDefinitions({ selectedProjectId, notDataAuthorization, contentTagServiceAccessPermission })).then(unwrapResult),
    [dispatch],
  );

  return {
    loaded,
    extensiveAttributeDefinitions,
    loadExtensiveAttributeDefinitions,
  };
};
